import { Controller } from "@hotwired/stimulus";

// Aide « mots-clés du modèle » dans la configuration des types de documents.
//
// La liste complète est rendue par le serveur, chaque ligne portant dans
// data-types les type_doc qui la concernent. Ce contrôleur ne fait que
// masquer ce qui ne correspond ni au type sélectionné ni à la recherche.
// Le serveur rend déjà le bon état pour le type enregistré : sans JS, la
// modale reste juste, elle perd seulement la mise à jour au changement.
//
//   <form data-controller="doc-keywords">
//     <select data-doc-keywords-target="type"
//             data-action="change->doc-keywords#refresh"> … </select>
//     … partial doc_keywords_help …
//   </form>
//
// Sur une modale sans sélecteur (documents d'adhésion), le type est figé par
// data-doc-keywords-type-value.
export default class extends Controller {
  static targets = ["type", "item", "group", "search", "count", "placeholder", "empty"];
  static values = { type: String };

  connect() {
    this.refresh();
  }

  // Le champ de recherche est dans un formulaire : Entrée ne doit pas
  // soumettre la création du type de document.
  ignoreEnter(event) {
    event.preventDefault();
  }

  refresh() {
    const type = this.currentType();
    const query = this.query();
    let visibles = 0;

    this.itemTargets.forEach((item) => {
      const types = (item.dataset.types || "").split(" ");
      const match = type && types.includes(type) && this.matchesQuery(item, query);
      item.hidden = !match;
      if (match) visibles += 1;
    });

    this.groupTargets.forEach((group) => {
      const items = group.querySelectorAll("[data-doc-keywords-target='item']");
      group.hidden = !Array.from(items).some((item) => !item.hidden);
    });

    if (this.hasCountTarget) this.countTarget.textContent = String(visibles);
    if (this.hasPlaceholderTarget) this.placeholderTarget.hidden = Boolean(type);
    if (this.hasEmptyTarget) this.emptyTarget.hidden = !type || visibles > 0;
  }

  currentType() {
    if (this.hasTypeTarget && this.typeTarget.value) return this.typeTarget.value;
    return this.typeValue || "";
  }

  query() {
    if (!this.hasSearchTarget) return "";
    return this.searchTarget.value.trim().toLowerCase();
  }

  matchesQuery(item, query) {
    if (!query) return true;
    return (item.dataset.search || "").includes(query);
  }
}
